import { Platform } from 'utils/platform';

// Keep in sync with: app_websocket_v2/packages/server/src/audience/platforms.ts
export type SocketPlatform = 'web' | 'ios' | 'android' | 'androidtv' | 'firetv' | 'ctv';

export function getSocketPlatform(): SocketPlatform {
  if (Platform.isFireTV) return 'firetv';
  if (Platform.isAndroidTV) return 'androidtv';
  if (Platform.isWebTV || Platform.isTV) return 'ctv';
  if (Platform.OS === 'web') return 'web';
  if (Platform.OS === 'ios') return 'ios';
  return 'android';
}
